module.exports = __webpack_public_path__ + "static/media/subICloud5.78603ed4.png";